import React, { Fragment } from 'react'

import Page from '../page'

import { translate } from '../helpers/stringTranslation'
import PortfolioArchiveComponent from '../components/portfolio/portfolioArchive'
import SEO from '../components/seo'

class PortfolioArchivePost extends Page {
  onMountGlobalState(state) {
    return {
      ...state,
      whiteLogo: false,
      headerWidget: 'portfolioFilter',
    }
  }

  render() {
    return (
      <Fragment>
        <SEO
          title={translate('portfolio')}
          {...this.props.pathContext}
          key="seo"
        />
        <PortfolioArchiveComponent data={this.props.data} />
      </Fragment>
    )
  }
}

export default PortfolioArchivePost

export const pageQuery = graphql`
  query PortfolioArchive($lang: String!) {
    items: allWordpressWpPortfolio(
      sort: { fields: [menu_order] }
      filter: { lang: { eq: $lang } }
    ) {
      edges {
        node {
          slug
          status
          title
          lang
          date
          portfolio_cat
          archive {
            size
            thumb {
              bgColor
              aspectRatio
              src
              srcSet
              srcWebp
              srcSetWebp
              sizes
            }
          }
        }
      }
    }
  }
`

/*
export const pageQuery = graphql`
  query ArticlesQuery($lang: String!) {
    articles: allWordpressPost(filter: { lang: { eq: $lang } }) {
      edges {
        node {
          ...PostExcerptFragment
        }
      }
    }
  }
`;
*/



// WEBPACK FOOTER //
// ./src/templates/portfolio-archive.js